module.exports = __webpack_public_path__ + "static/map-bg-c60e42336194e28c9df376793a6d081b.jpg";